import {FC, useEffect} from 'react'
import {useLocation} from 'react-router'
import {DrawerComponent} from '../../assets/ts/components'
import {WithChildren} from '../../helpers'

const Content: FC<WithChildren> = ({children}) => {
  const location = useLocation()
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  return (
    <div
      id='kt_content_container'
      className='flex-1 px-4 py-6 md:px-6 lg:px-8 overflow-y-auto h-full'
    >
      {children}
    </div>
  )
}

export {Content}
